import { useQuery } from '@tanstack/react-query';
import z from 'zod';
import { LibraryRuleMetadata, libraryRuleSchema } from 'schemas/LibraryRule.schema.ts';
import useAuth from 'hooks/useAuth.ts';
import { apiFetch } from 'utils/apiUtils';

interface IFetchLibraryRulesVariables {
  teamId: string,
}

export default function useFetchTeamRuleLibrary({ teamId }: IFetchLibraryRulesVariables) {
  const { tokens } = useAuth();

  return useQuery({
    queryKey: ['team', { teamId }],
    retry: false,
    queryFn: async (): Promise<LibraryRuleMetadata[]> => {
      const response = await apiFetch<unknown>({
        path: `team/${teamId}/rule_library`,
        method: 'GET',
        accessToken: String(tokens.accessToken),
      });

      const parsedResponse = z.array(libraryRuleSchema).safeParse(response);

      if (!parsedResponse.success) {
        throw new Error('Library rules not of expected shape (500)');
      }

      return parsedResponse.data;
    },
  });
}
